export default __webpack_public_path__ + "static/media/twitter.32481f53.svg";